const selectBestOfferInitialState = {
    isPending: false,
    bestOffers: [],
    selectedOffer: -1,
};

export default selectBestOfferInitialState;



// WEBPACK FOOTER //
// ./src/app/FormStepper/SelectBestOffer/selectBestOfferInitialState.js